import { useFeatureFlag } from 'shared/domains/featureFlag';
import { getDashboardsMock } from './mocks';
/**
 * NOTE: This is a mock until we have a real API.
 */
const LS_KEY = 'pl.powerinsights';
export const useGetDashboard = () => {
    const insightsFlag = useFeatureFlag('feature_new_insights_save');
    const dashboards = getDashboardsMock();
    const get = () => {
        if (!insightsFlag) {
            return dashboards;
        }
        try {
            const lsData = localStorage.getItem(LS_KEY);
            if (lsData) {
                const parsedData = JSON.parse(lsData);
                const response = (Array.isArray(parsedData) ? parsedData : [parsedData]);
                return response;
            }
            return dashboards;
        }
        catch (e) {
            return dashboards;
        }
    };
    const getById = (id) => get().find(dashboard => dashboard.id === id);
    const upsert = (dashboard) => {
        const currentDashboards = get();
        const exists = currentDashboards.find(d => d.id === dashboard.id);
        const updatedDashboards = exists
            ? currentDashboards.map(d => (d.id === dashboard.id ? dashboard : d))
            : [...currentDashboards, dashboard];
        localStorage.setItem(LS_KEY, JSON.stringify(updatedDashboards));
    };
    const remove = (id) => {
        const currentDashboards = get();
        const updatedDashboards = currentDashboards.filter(dashboard => dashboard.id !== id);
        localStorage.setItem(LS_KEY, JSON.stringify(updatedDashboards));
        window.location.reload();
    };
    const loadDefaults = () => {
        localStorage.removeItem(LS_KEY);
        window.location.reload();
    };
    return {
        get,
        upsert,
        getById,
        remove,
        loadDefaults,
    };
};
